/**
 * User Profile Model
 * Stores user profile information for personalization
 */

export interface UserProfile {
  fullName?: string;
  dateOfBirth?: string; // ISO date string
  placeOfBirth?: {
    city?: string;
    country?: string;
  };
  gender?: string;
  occupation?: string;
  interests?: string[];
  timeOfBirth?: string; // HH:MM format, 24-hour (optional)
  updatedAt?: string;
}

export function createUserProfile(
  fullName?: string,
  dateOfBirth?: string,
  placeOfBirth?: { city?: string; country?: string },
  gender?: string,
  occupation?: string,
  interests?: string[],
  timeOfBirth?: string
): UserProfile {
  return {
    fullName,
    dateOfBirth,
    placeOfBirth,
    gender,
    occupation,
    interests,
    timeOfBirth,
    updatedAt: new Date().toISOString(),
  };
}

/**
 * Calculate profile completion percentage
 * Required fields: fullName, dateOfBirth, placeOfBirth, gender, occupation, interests (6 fields = 100%)
 * Optional: timeOfBirth (does not count toward completion)
 */
export function calculateProfileCompletion(profile: UserProfile | null): number {
  if (!profile) return 0;

  const requiredFields = [
    profile.fullName,
    profile.dateOfBirth,
    profile.placeOfBirth?.city || profile.placeOfBirth?.country,
    profile.gender,
    profile.occupation,
    profile.interests && profile.interests.length > 0,
  ];

  const filledFields = requiredFields.filter(Boolean).length;
  const totalFields = requiredFields.length;

  return Math.round((filledFields / totalFields) * 100);
}
